import { render } from "./FavoritesSection.vue?vue&type=template&id=6772385d"
import script from "./FavoritesSection.vue?vue&type=script&lang=js"
export * from "./FavoritesSection.vue?vue&type=script&lang=js"

import "./FavoritesSection.vue?vue&type=style&index=0&id=6772385d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__